import { render, staticRenderFns } from "./notFoundPage.vue?vue&type=template&id=7163a1e1&scoped=true"
import script from "./notFoundPage.vue?vue&type=script&lang=js"
export * from "./notFoundPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163a1e1",
  null
  
)

export default component.exports